import React from 'react';

const Bottom1Shape = ({ className }) => {
  return (
    <svg
      className={className}
      width="561"
      height="681"
      viewBox="0 0 561 681"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M401.854 133.355C479.628 249.177 412.873 430.275 373 496L-7.25991 496L-7.25992 308.019L245.126 133.285C326.219 80.3872 383.4 111.291 401.854 133.355Z"
        fill="white"
      />
    </svg>
  );
};

export default Bottom1Shape;
